module.exports = __webpack_public_path__ + "img/empty.5763b0b3.svg";